import React from "react";
import Typography from "@material-ui/core/Typography";
import SnackbarAlert from "../components/SnackbarAlert";
import {panelGeneralResources} from "../endpoints";
import TablaPanelAuditoriasVisual from "../components/TablaPanelAuditoriasVisual";
import TextField from "@mui/material/TextField";

class PanelAuditorias extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disponibles: [],
            total: 0,
            paginationModel: { page: 0, pageSize: 25 },
            sortModel: [],   // 👈 IMPORTANTE
            search: ""
        };
    }

    componentDidMount(){
        this.obtenerDatos()
    }

    obtenerDatos = () => {
        const { page, pageSize } = this.state.paginationModel;
        const { search, sortModel } = this.state;

        const sortField = (sortModel && sortModel.length > 0) ? sortModel[0].field : undefined;
        const sortDir = (sortModel && sortModel.length > 0) ? sortModel[0].sort : undefined;

        panelGeneralResources
            .getAuditoriasPanelVisual(page, pageSize, search, sortField, sortDir)
            .then(res => res.json())
            .then(data => {
            this.setState({
                disponibles: data.inv_disponibles,
                total: data.total
            });
        });
    };

    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>Panel Auditorias Visual</Typography>
                <TextField
                    label="Buscar"
                    variant="outlined"
                    size="small"
                    value={this.state.search}
                    onChange={(e) =>
                        this.setState(
                        { search: e.target.value, paginationModel: { ...this.state.paginationModel, page: 0 } },
                        this.obtenerDatos
                        )
                    }
                    style={{ marginBottom: 16 }}
                    />
                <TablaPanelAuditoriasVisual
                    disponibles={this.state.disponibles}
                    total={this.state.total}
                    paginationModel={this.state.paginationModel}
                    sortingMode="server" // 👈 Crucial
                    sortModel={this.props.sortModel} // 👈 Esto hace que la flecha cambie visualmente
                    onPageChange={(model) =>
                        this.setState(
                            { paginationModel: model },
                            this.obtenerDatos
                        )
                    }
                    onSortChange={(model) => 
                        this.setState({ sortModel: model }, this.obtenerDatos)
                    }
                />               
                {this.state.openSnack? <SnackbarAlert severity={this.state.severity} message={this.state.message}/> : null}
            </div>
        )
    }
}

export default PanelAuditorias;